import {html, css, LitElement} from 'lit';

export class DzGroupSelect extends LitElement {

    constructor() {
        super()
        this.selected = []
        this.shiftKey = false
    }

    connectedCallback() {
        super.connectedCallback()
        this.addEventListener("select", evt => {
            if (this.shiftKey) {
                this.selected.push(evt.target)
            } else {
                for (let item of this.selected) {
                    item.deselect()
                }
                this.selected = [evt.target]
            }
        })

        this.addEventListener("deselect", evt => {
            this.selected = this.selected.filter(item => item !== evt.target)
        })

        this.addEventListener("pointermove", evt => {
            this.shiftKey = evt.shiftKey
        })
    }

    render() {
        return html`<slot></slot>`
    }
}

customElements.define('dz-group-select', DzGroupSelect)